export const landedCostsTranslations = {
  ar: {
    title: 'تكاليف إضافية على المشتريات',
    addNew: 'تكلفة إضافية جديدة',
    edit: 'تعديل التكلفة الإضافية',
    view: 'عرض التكلفة الإضافية',
    purchaseInvoice: 'فاتورة الشراء',
    loadInvoice: 'تحميل الفاتورة',
    invoiceSerial: 'رقم الفاتورة',
    invoiceNotFound: 'فاتورة الشراء غير موجودة',
    date: 'التاريخ',
    vendor: 'مورد التكلفة',
    branch: 'الفرع',
    notes: 'ملاحظات',
    allocationMethod: 'طريقة التوزيع',
    byValue: 'حسب القيمة',
    byQuantity: 'حسب الكمية',
    byWeight: 'حسب الوزن',
    manual: 'يدوي',
    charges: 'المصاريف الإضافية',
    addCharge: 'إضافة مصروف',
    chargeType: 'النوع',
    description: 'البيان',
    amount: 'المبلغ',
    account: 'الحساب الدائن',
    allocation: 'توزيع التكاليف على الأصناف',
    item: 'الصنف',
    quantity: 'الكمية',
    originalUnitCost: 'تكلفة الشراء الأصلية',
    additionalCost: 'التكلفة الإضافية',
    landedUnitCost: 'التكلفة النهائية',
    originalTotal: 'إجمالي الشراء الأصلي',
    additionalTotal: 'إجمالي التكاليف الإضافية',
    landedTotal: 'التكلفة الفعلية للبضاعة',
    saveDraft: 'حفظ مسودة',
    post: 'ترحيل إلى المخزون',
    cancelDoc: 'إلغاء الترحيل',
    deleteDraft: 'حذف المسودة',
    posted: 'مرحّل',
    draft: 'مسودة',
    cancelled: 'ملغى',
    saved: 'تم حفظ التكلفة الإضافية',
    postedOk: 'تم ترحيل التكلفة الإضافية وتحديث تكلفة المخزون',
    cancelledOk: 'تم إلغاء التكلفة الإضافية وعكس أثرها على المخزون',
    deletedOk: 'تم حذف المسودة',
    confirmPost: 'سيتم توزيع التكاليف على الأصناف وزيادة تكلفة المخزون دون تغيير سعر الشراء الأصلي في الفاتورة. متابعة؟',
    confirmCancel: 'سيتم عكس التكلفة الإضافية عن المخزون والقيد المحاسبي. متابعة؟',
    confirmDelete: 'حذف هذه المسودة؟',
    originalPriceKept: 'سعر الشراء الأصلي في الفاتورة لا يتغير',
    noLines: 'لا توجد أصناف مخزون في الفاتورة لتوزيع التكاليف',
    customs: 'جمارك',
    freight: 'نقل',
    clearance: 'تخليص',
    insurance: 'تأمين',
    loading: 'تحميل',
    unloading: 'تنزيل',
    other: 'أخرى',
    searchInvoice: 'ابحث برقم الفاتورة',
    linkedDocs: 'مستندات التكلفة الإضافية',
    addForInvoice: 'إضافة تكاليف إضافية',
    remainingHint: 'البيع وتكلفة البضاعة المباعة يعتمدان على التكلفة النهائية بعد التوزيع',
  },
  en: {
    title: 'Landed / Additional Purchase Costs',
    addNew: 'New additional cost',
    edit: 'Edit additional cost',
    view: 'View additional cost',
    purchaseInvoice: 'Purchase invoice',
    loadInvoice: 'Load invoice',
    invoiceSerial: 'Invoice no.',
    invoiceNotFound: 'Purchase invoice not found',
    date: 'Date',
    vendor: 'Cost vendor',
    branch: 'Branch',
    notes: 'Notes',
    allocationMethod: 'Allocation method',
    byValue: 'By value',
    byQuantity: 'By quantity',
    byWeight: 'By weight',
    manual: 'Manual',
    charges: 'Additional charges',
    addCharge: 'Add charge',
    chargeType: 'Type',
    description: 'Description',
    amount: 'Amount',
    account: 'Credit account',
    allocation: 'Allocate costs to items',
    item: 'Item',
    quantity: 'Qty',
    originalUnitCost: 'Original purchase cost',
    additionalCost: 'Additional cost',
    landedUnitCost: 'Landed unit cost',
    originalTotal: 'Original purchase total',
    additionalTotal: 'Additional costs total',
    landedTotal: 'Actual cost of goods',
    saveDraft: 'Save draft',
    post: 'Post to inventory',
    cancelDoc: 'Cancel posting',
    deleteDraft: 'Delete draft',
    posted: 'Posted',
    draft: 'Draft',
    cancelled: 'Cancelled',
    saved: 'Additional cost saved',
    postedOk: 'Additional cost posted and inventory cost updated',
    cancelledOk: 'Additional cost reversed from inventory',
    deletedOk: 'Draft deleted',
    confirmPost: 'Costs will be allocated to items and inventory cost will increase. The original purchase price on the invoice will not change. Continue?',
    confirmCancel: 'This will reverse the inventory cost and the journal. Continue?',
    confirmDelete: 'Delete this draft?',
    originalPriceKept: 'The original purchase price on the invoice is not changed',
    noLines: 'This invoice has no stock lines to allocate costs to',
    customs: 'Customs',
    freight: 'Freight',
    clearance: 'Clearance',
    insurance: 'Insurance',
    loading: 'Loading',
    unloading: 'Unloading',
    other: 'Other',
    searchInvoice: 'Search by invoice number',
    linkedDocs: 'Landed cost documents',
    addForInvoice: 'Add additional costs',
    remainingHint: 'Sales and COGS use the landed cost after allocation',
  },
  fr: {
    title: 'Coûts additionnels d\'achat',
    addNew: 'Nouveau coût additionnel',
    edit: 'Modifier le coût additionnel',
    view: 'Voir le coût additionnel',
    purchaseInvoice: 'Facture d\'achat',
    loadInvoice: 'Charger la facture',
    invoiceSerial: 'N° facture',
    invoiceNotFound: 'Facture d\'achat introuvable',
    date: 'Date',
    vendor: 'Fournisseur du coût',
    branch: 'Agence',
    notes: 'Notes',
    allocationMethod: 'Méthode de répartition',
    byValue: 'Par valeur',
    byQuantity: 'Par quantité',
    byWeight: 'Par poids',
    manual: 'Manuel',
    charges: 'Frais additionnels',
    addCharge: 'Ajouter un frais',
    chargeType: 'Type',
    description: 'Libellé',
    amount: 'Montant',
    account: 'Compte crédit',
    allocation: 'Répartir sur les articles',
    item: 'Article',
    quantity: 'Qté',
    originalUnitCost: 'Coût d\'achat d\'origine',
    additionalCost: 'Coût additionnel',
    landedUnitCost: 'Coût unitaire final',
    originalTotal: 'Total d\'achat d\'origine',
    additionalTotal: 'Total des frais',
    landedTotal: 'Coût réel des marchandises',
    saveDraft: 'Enregistrer le brouillon',
    post: 'Comptabiliser au stock',
    cancelDoc: 'Annuler',
    deleteDraft: 'Supprimer le brouillon',
    posted: 'Comptabilisé',
    draft: 'Brouillon',
    cancelled: 'Annulé',
    saved: 'Coût additionnel enregistré',
    postedOk: 'Coût additionnel comptabilisé et stock mis à jour',
    cancelledOk: 'Coût additionnel contre-passé',
    deletedOk: 'Brouillon supprimé',
    confirmPost: 'Les frais seront répartis et le coût de stock augmentera. Le prix d\'achat d\'origine ne change pas. Continuer ?',
    confirmCancel: 'Cela contre-passera le stock et l\'écriture. Continuer ?',
    confirmDelete: 'Supprimer ce brouillon ?',
    originalPriceKept: 'Le prix d\'achat d\'origine sur la facture ne change pas',
    noLines: 'Cette facture n\'a pas de lignes de stock',
    customs: 'Douane',
    freight: 'Fret',
    clearance: 'Dédouanement',
    insurance: 'Assurance',
    loading: 'Chargement',
    unloading: 'Déchargement',
    other: 'Autre',
    searchInvoice: 'Rechercher par n° de facture',
    linkedDocs: 'Documents de coût additionnel',
    addForInvoice: 'Ajouter des coûts additionnels',
    remainingHint: 'Les ventes et le CMV utilisent le coût final après répartition',
  },
}
